import React from "react";
import "./receipt.css";
import { BsFillPatchCheckFill } from "react-icons/bs";
import moment from "moment";

const Receipt = ({ data, onClose }) => {
  const handlePrint = () => {
    window.print();
  };

  /* 
  {
    "code": 200,
    "status": null,
    "message": "Done",
    "duration": null,
    "requestId": null,
    "data": {
        "_id": "643ed81a77c3ae05dd402b95",
        "msisdn": "233558365033",
        "campaignId": "62716fbcba13726d1a3f9d07",
        "gender": null,
        "region": null,
        "ageGroup": null,
        "rewarded": true,
        "wins": 1,
        "entries": null,
        "date": 1681840154575,
        "top": false,
        "show": true,
        "receiptId": null,
        "proxyNumber": null,
        "amount": "0.2",
        "rewardType": "AIRTIME",
        "entrantData": null
    }
}
  
  */

  return (
    <div className="bg-[#994023] pb-4 px-4 pt-4 rounded-t-[20px] receipt_container_scale">
      <div className="receipt_container shadow z-50">
        <p className="receipt-item absolute  bottom-2 left-4 text-[10px] flex flex-col font-semibold opacity-60 ">
          Powered by RANCARD
        </p>

        <div className="flex flex-col w-full">
          <div className="top-card min-h-[235px] max-h-[235px]  bg-white py-6 flex flex-col items-center justify-center w-full">
            <div className="receipt-heading ">
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-[70px] h-[70px] text-[#ff6a3a]"
              >
                <path
                  strokeLineCap="round"
                  strokeLineJoin="round"
                  d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
                />
              </svg> */}
              <BsFillPatchCheckFill className="text-[42px] text-[#ff6a3a]" />
            </div>
            <div className="receipt-item flex items-center flex-col justify-center gap-4">
              <div className="flex flex-col">
                <h1 className="text-center text-lg font-bold">
                  Reward Success
                </h1>

                {data?.receiptId && (
                  <p
                    title="Receipt ID"
                    className=" text-[12px] text-center flex flex-col font-semibold opacity-60 "
                  >
                    {/* <span className="text-[9px] font-medium h-[15px] ">
              Receipt ID:
            </span>{" "} */}
                    {data?.receiptId}
                  </p>
                )}
                <p className="text-center text-sm opacity-30 font-semibold">
                  You have successfully rewarded {data?.msisdn}.
                </p>
              </div>
              <div className="receipt-item flex items-center flex-col justify-center">
                <p className="text-center text-sm opacity-30 font-semibold">
                  Total Amount
                </p>
                <h1 className="text-center text-xl font-bold">
                  GH₵ {Number(data?.amount)?.toFixed(2) ?? "0.00"}
                </h1>
              </div>
            </div>
          </div>
          <div className="bottom-card bg-white py-6">
            {/* <div className="receipt-heading">RECEIPT</div> */}
            <div className="flex flex-col gap-1 bg-[#0000000b] rounded-lg py-4 px-4">
              <div className="receipt-item flex justify-between gap-2 items-center text-sm font-bold opacity-60">
                Date:{" "}
                <span>
                  {data?.date &&
                    moment(new Date(data?.date)).format("DD/MM/YYYY, h:mm A")}
                </span>
              </div>
              <div className="receipt-item flex justify-between gap-2 items-center text-sm font-bold opacity-60">
                Receiver: <span>{data?.msisdn}</span>
              </div>
              {data?.proxyNumber && (
                <div className="receipt-item flex justify-between gap-2 items-center text-sm font-bold opacity-60">
                  Proxy number: <span>{data?.proxyNumber}</span>
                </div>
              )}

              <div className="receipt-item flex justify-between gap-2 items-center text-sm font-bold opacity-60">
                Reward Type: <span>{data?.rewardType}</span>
              </div>
              <div className="receipt-item flex justify-between gap-2 items-center text-sm font-bold opacity-60">
                Amount:{" "}
                <span>GH₵ {Number(data?.amount)?.toFixed(2) ?? "0.00"}</span>
              </div>
            </div>

            <div className="w-full">
              <button
                onClick={() => {
                  onClose && onClose();
                }}
                className="w-full hide__p bg-[#ff6a3a] hover:scale-105 duration-150 ease-in transition-all text-white py-2 rounded-lg mt-4"
              >
                Done
              </button>

              <button
                onClick={handlePrint}
                className="w-full hide__p hover:opacity-100 text-right text-sm opacity-80 duration-150 ease-in underline-offset-2 transition-all text-blue-500 underline py-2 rounded-lg mt-4"
              >
                Print Receipt
              </button>
            </div>
          </div>
        </div>
        <span class="bottom-dots">
          <span class="section dots">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </span>
      </div>
    </div>
  );
};

export default Receipt;
